<!-- 左侧菜单导航栏组件 -->
<template>
  <!-- 菜单笔记,useful
  router模式：激活导航时以 index 字段作为 path 进行路由跳转。
  default-active：当前激活的导航，以index字段为值。如果组件渲染前有默认值，则渲染后会按照该值来展开的导航。
  unique-opened：保证只有一个子菜单展开。同样以index字段作为索引，如果某些菜单的index重复或者没有则会使该功能失效 -->
    <div class="app-nav-wrap">
        <el-menu unique-opened :default-active="$route.path" class="el-menu-vertical-demo" router @open="handleOpen" @close="handleClose">
            <el-menu-item  v-for="(menu,index) in menus" :index="menu.menuUrl" :key="index" v-if="!menu.children">
                <i :class="menu.menuIcon"></i><span>{{menu.menuName}}</span>
            </el-menu-item>
            <el-submenu v-for="(menu,index) in menus" :index="menu.menuUrl" :key="index" v-if="menu.children">
                <template slot="title">
                    <i :class="menu.menuIcon"></i>
                    <span>{{menu.menuName}}</span>
                </template>
                <el-menu-item-group v-for="(item,index) in menu.children" :key="index">
                    <el-menu-item :index="item.menuUrl">{{item.menuName}}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
</template>

<script>
    export default {
        props: {
            menus: {
                type:Array,
                required:true
            }
        },
        data () {
            return {
                isCollapse:true,
                // menus: []
            }
        },
        mounted () {
            //获取菜单列表
            this.getMenueList();
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            getMenueList(){
                // 刷新时以当前路由做为tab加入tabs
                if (this.$route.path !== '/' && this.$route.path.indexOf('welcome') == -1) {
                    this.$store.commit('add_tabs', {route: '/welcome', name: '首页'});
                    this.$store.commit('add_tabs', {route: this.$route.path , name: this.$route.name });
                    this.$store.commit('set_active_index', this.$route.path);
                } else {
                    this.$store.commit('add_tabs', {route: '/welcome', name: '首页'});
                    this.$store.commit('set_active_index', '/welcome');
                    this.$router.push('/welcome');
                }
            }
        },
        computed: {
            options () {
                return this.$store.state.options;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AppNav.vue?74e90984